module.exports = __webpack_public_path__ + "static/img/ys.5817d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introdution/ys.png
// module id = jv2/
// module chunks = 1